import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons"
import fallbackImg from "../img/fallback.jpg"
const Gallery = ({ images, dropdownImage }) => {
  if (!images || images.length === 0) return null
  const [selectedImage, setSelectedImage] = useState(
    images.findIndex(img => img.title === dropdownImage) || 0
  )
  useEffect(() => {
    if (images.find(img => img.title === dropdownImage)) {
      setSelectedImage(images.findIndex(img => img.title === dropdownImage))
    }
  }, [dropdownImage])
  const image =
    (images && images[selectedImage]?.full) || (images && images[0].full)
  return (
    <div className="sc-gallery">
      <div className="sc-gallery-image">
        {image ? (
          <Img fluid={image} style={{ borderRadius: "20px" }} />
        ) : (
          <img style={{ borderRadius: "20px" }} src={fallbackImg} />
        )}
        {images.length > 1 && (
          <div className="sc-gallery-image-controls">
            <button
              onClick={() => setSelectedImage(selectedImage - 1)}
              disabled={selectedImage === 0}
              className={`sc-gallery-image-controls__button ${
                selectedImage === 0 ? "disabled" : ""
              }`}
            >
              <FontAwesomeIcon
                className="sc-gallery-icon"
                icon={faAngleLeft}
                size="3x"
              />
            </button>
            <button
              onClick={() => setSelectedImage(selectedImage + 1)}
              disabled={selectedImage === images.length - 1}
              className={`sc-gallery-image-controls__button ${
                selectedImage === images.length - 1 ? "disabled" : ""
              }`}
            >
              <FontAwesomeIcon
                className="sc-gallery-icon"
                icon={faAngleRight}
                size="3x"
              />
            </button>
          </div>
        )}
      </div>

      {images.length > 1 && (
        <div>
          {images.map((image, i) => (
            <button
              key={i}
              className={`sc-gallery-thumb ${
                selectedImage === i ? "active" : ""
              }`}
              onClick={() => setSelectedImage(i)}
            >
              <Img fluid={image.thumb} />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

Gallery.propTypes = {
  images: PropTypes.array,
  dropdownImage: PropTypes.object,
}

export default Gallery
